<template>
    <div>
      <staff-entry-form :formSchema="formSchema" :salary_category="salary_category" @reloadData="close"></staff-entry-form>
           <Snackbar :SnackbarVal="SnackbarVal"></Snackbar>

              <!-- Confirmation delete box -->
        <v-layout row justify-center>
            <v-dialog v-model="confirmModel" max-width="290">
                <v-card>
                    <v-card-text>Are you sure you want to delete this data?</v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="green darken-1" flat="flat" @click.native="confirmModel = false">Disagree</v-btn>
                        <v-btn color="green darken-1" flat="flat" @click.native="confirmDelete(row_index, delete_id)">
                            Agree
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-layout>
        <!-- /Confirmation delete box -->
     <v-container>
 <v-card>
    <v-card-title>
	<span class="headline">Outsource Staff Information List</span>
      <v-spacer></v-spacer>
        <DatePicker
          :key="1"
          :inputData="{index:1,fieldName:'start_date', fieldValue:start_date, label:'Start Date'}"
          @setValue="setStartDateValue"
        ></DatePicker>
      
      <v-spacer></v-spacer>
       <DatePicker
        :key="2"
        :inputData="{index:2,fieldName:'end_date', fieldValue:end_date, label:'End Date', disabled:'1'}"
        @setValue="setEndDateValue"
        ref="setRange"
       ></DatePicker>
      <v-spacer></v-spacer>
      <v-autocomplete            
      label="Status"
      :items="searchStatus"
      item-text="name"
      item-value="id"
      clearable
      single-line hide-details         
      v-model="status"
      @input="findByStatus()"
      ></v-autocomplete>
      &nbsp;&nbsp;
      <v-text-field
        v-model="search"
        append-icon="search"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="desserts"
      :pagination.sync="pagination"
      :total-items="totalDesserts"
      :loading="loading"
      
    >
    <template slot="items" slot-scope="props">
            <td class="text-xs-left">{{ ++(props.index) }}</td>
            <td class="text-xs-left">{{ props.item.staff_id }}</td>
            <td class="text-xs-left">{{ props.item.staff_name }}</td>
            <td class="text-xs-left">{{ props.item.designation }}</td>
            <td class="text-xs-left">{{ props.item.nid_number }}</td>
            <td class="text-xs-left">{{ props.item.category_name }}</td>
            <td class="text-xs-left">{{ changeFormateDMY(props.item.join_date) }}</td>
            <td class="text-xs-left">{{ changeFormateDMY(props.item.end_date) }}</td>
            <td class="text-xs-left">{{ props.item.mobile_no }}</td>
            <td class="text-xs-left">
               <span v-if="props.item.active" class="active">Yes</span>
              <span v-else class="in-active">No</span>
            </td>
            
            <td class="justify-center layout px-0">
                <v-btn icon class="mx-0"  @click="editItem(props.item)">
                    <v-icon color="teal">edit</v-icon>
                </v-btn>
                <v-btn icon class="mx-0"  @click="deleteItem(props.index, props.item.id)">
                    <v-icon color="pink">delete</v-icon>
                </v-btn>
            </td>

        </template> 

         <template slot="no-data" class="error">
       <div align="center"> No Data Found</div>
    </template>
    </v-data-table>
      <!-- <v-data-table item-key="name" class="elevation-1" loading loading-text="Loading... Please wait"></!--> 
  </v-card>
     </v-container>
     
    </div>
</template>
<script>
const commonService = require('../../../services/common.service');

import {preFix} from '../../../vuex/api'
import DatePicker from "../../global/date_picker";
import staffEntryForm from './staff_entry_form'
import Axios from 'axios'
export default {
    components:{
        DatePicker,
        staffEntryForm
    },
    data: () => ({
      start_date:'',
      end_date:'',
      status:'',
      showForm : false,
      valid: true,
      dialog: false,
      dialogEditForm:false,
      selected:[],
      searchStatus:[
        {id:1, name:'Active'},
        {id:2, name:'In-Active'},
      ],
      /*------------- Datatable ---------------*/
      serialNumber: 0,
      sort: "",
      queryData: {
        sortBy: "id",
        descending: true,
        page: 1,
        rowsPerPage: 5,
        totalItems: 0,
        search_val: ""
      },

      search: "",
      totalDesserts: 0,
      desserts: [],
      loading: true,
      pagination: {},       
      headers: [
      {
        text: 'Sl#',
        align: 'left',
        sortable: false,
        value: 'id'
      },
      {
        text: ' ID',
        align: 'left',
        sortable: false,
        value: 'staff_id'
      },
      { text: ' Name', align: 'left', value: 'staff_name' },
      { text: ' Designation', value: 'designation' },
      { text: 'NID', value: 'nid_number' },
      { text: 'Salary Category', value: 'category_name' },
      { text: 'Start Date', value: 'join_date' },
      { text: 'End Date', value: 'end_date' },
      { text: 'Mobile Number.', value: 'mobile_no' },
      { text: 'Active', value: 'active' },
      { text: 'Actions', value: '', align: 'center'},

      
      ],
      items: [],
      
    formSchema: {
      id: "",
      staff_id: "",
      staff_name: "",
      designation: "",
      organization: "",
      nid_number: "",
      join_date: "",
      mobile_no: "",
      email_id: "",
      salary_category: "",
      start_date: "",
      end_date: "",
      address: "",
      permanent_address: "",
      active:""
    },
      SnackbarVal: {
      snackbar: false,
      color: "success",
      message: "",
    },
      delete_id:'',
      row_index:'',
      dialog2: false,
      snackbar: false,
      color: 'success',
      mode: '',
      timeout: 3000,
      left:'left',
      message: '',
      confirmModel: false,
      select: null,
      adminTypelist:[
        {id:1, name:'DIA'},
        {id:3, name:'Institute'},
      ],
      salary_category:[],
      instituteShow:true,
    }),
watch: {
        params: {
          handler() {
            
            this.liveSearch().then(data => {
              this.desserts = data.items;
        this.totalDesserts = data.total;
            });
          },
          deep: true
        },

        userRole: function(){}
      },
    computed: {
      params(nv) {
      return {
        ...this.pagination,
        query: this.search
      };
     },
      userRole() {
                let role = this.$store.getters.get_USER_ROLE_DATA;               
                this.showForm = role.saveButton
                return role;
            }
    },

    methods: {
      setStartDateValue(data) {
        let index = data.index;
        this.start_date = data.value;

        if(data.index === 1){
          this.end_date = 0
          this.$refs.setRange.setRange(data.value);
        }
        this.findByStartDate()
        console.log(this.start_date,this.end_date)
      },
      setEndDateValue(data) {
        let index = data.index;
        this.end_date = data.value;
        this.findByEndDate()
        console.log(this.start_date,this.end_date)
      },
      findByStartDate(){
        this.liveSearch().then(data => {          
          this.desserts = data.items;
        this.totalDesserts = data.total;
      });
      },
      findByEndDate(){
        this.liveSearch().then(data => {          
          this.desserts = data.items;
        this.totalDesserts = data.total;
      });
      },
      findByStatus(){
        this.liveSearch().then(data => {          
          this.desserts = data.items;
        this.totalDesserts = data.total;
      });
      },
      liveSearch(){
         this.loading = true;
      return new Promise((resolve, reject) => {
        const { sortBy, descending, page, rowsPerPage } = this.pagination;
        let search = this.search.trim().toLowerCase();

        let query_Data = this.queryData;

        (query_Data.sortBy = "id"),
          (query_Data.descending = this.pagination.descending),
          (query_Data.page = this.pagination.page),
          (query_Data.rowsPerPage = this.pagination.rowsPerPage),
          (query_Data.start_date = (this.start_date) ? this.changeFormateYMD(this.start_date) : ''),
          (query_Data.end_date = (this.end_date) ? this.changeFormateYMD(this.end_date) : ''),
          (query_Data.status = (this.status) ? this.status : ''),
          (query_Data.search_val = this.search);

        const serialNumber =
          this.pagination.rowsPerPage * this.pagination.page -
          this.pagination.rowsPerPage;
        this.serialNumber = serialNumber + 1;

        commonService
          .getServerSideData(query_Data, "outsource-staff-info-list")
          .then(res => {
            let items = res.data;
            const total = res.totalRecords;
            if (search) {
              items = items.filter(item => {
                return Object.values(item)
                  .join(",")
                  .toLowerCase()
                  .includes(search);
              });
            }

            if (this.pagination.sortBy) {
              items = items.sort((a, b) => {
                const sortA = a[sortBy];
                const sortB = b[sortBy];

                if (descending) {
                  if (sortA < sortB) return 1;
                  if (sortA > sortB) return -1;
                  return 0;
                } else {
                  if (sortA < sortB) return -1;
                  if (sortA > sortB) return 1;
                  return 0;
                }
              });
            }

            setTimeout(() => {
              this.loading = false;
              resolve({
                items,
                total
              });
            }, 300);
          });
      });
        
    },
     getDataFromApi(){  

      commonService.getAllData('outsource_staff').then(res => {                                    
        this.items = res.data;
        this.loading = false;
      });

      },
     getSalaryCategory(){  

        commonService.getAllData('get_salary_category').then(res => {                                    
          this.salary_category = res.data;
        });

      },

       changeSort (column) {
        if (this.pagination.sortBy === column) {
          this.pagination.descending = !this.pagination.descending
        } else {
          this.pagination.sortBy = column
          this.pagination.descending = false
        }
      },

      validateBeforeSubmit(e) {

      },
      reloadData(){
        this.showForm = this.userRole.saveButton;
        this.getDataFromApi()
        
      
      },

      editItem (item) {
        item.join_date = this.changeFormateDMY(
          item.join_date
          );
        // item.start_date = this.changeFormateDMY(
        //   item.start_date
        //   );
        item.end_date = this.changeFormateDMY(
          item.end_date
          );
        this.formSchema = item;
        this.showForm = true
        window.scrollTo({ // scroling to top
			    top: 0,
			    left: 100,
			    behavior: "smooth"
			  });
      },

      deleteItem (index,id) {          
        this.row_index = index;
        this.delete_id = id;                
        this.confirmModel = true;
      },

      confirmDelete(row_index,id){                    
        commonService.deleteRow(id, 'outsource_staff').then(res => {
             if (res.status == 1) {
            this.items.splice(row_index, 1);
            this.getDataFromApi();
          } else {
            this.SnackbarVal.color = "error";
          }
          this.SnackbarVal.message = res.message;
          this.SnackbarVal.snackbar = true;

          this.confirmModel = false;
          this.dialog2 = false;
          });       
      },

      close(res) {
      let $this = this;
      if (res.status == 1) {
        if (res.action == "add") {
          // $this.items.unshift({ ...res.data });
          this.liveSearch().then(data => {       
          this.desserts = data.items;
          this.totalDesserts = data.total;
         });
        }
        if (res.action == "edit") {
          // let findindex = this.items.findIndex(
          //   (item) => item.id == res.data.id
          // );
          // this.row_index = findindex;
          // this.$set(this.items, this.row_index, { ...res.data });
          // this.row_index = "";
          // this.formSchema.id = 0;
          
          this.liveSearch().then(data => {       
          this.desserts = data.items;
          this.totalDesserts = data.total;
         });
        }
        window.scrollTo({
          left: 0,
          top:
            document.body.scrollHeight || document.documentElement.scrollHeight,
          behavior: "smooth",
        });
      }
      this.SnackbarVal.color = "success";
      this.SnackbarVal.message = res.message;
      this.SnackbarVal.snackbar = true;
    },

    },

    mounted () {
      this.getDataFromApi();
      this.getSalaryCategory();
    },
}
</script>


// WEBPACK FOOTER //
// src/components/administration/staff_entry/staff_entry_list.vue